"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: ${({ width }) => (width ? `${width}px` : "100%")};
  margin: 16px 0;
  position: relative;
`;
const Label = styled_components_1.default.label `
  color: ${({ theme }) => theme.text.secondary};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 4px;
`;
const Textarea = styled_components_1.default.textarea `
  color: ${({ theme }) => theme.text.primary};
  font-size: 12px;
  line-height: 15px;
  font-weight: 400;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: ${({ disabled, theme }) => disabled ? theme.neutral.lighter : theme.white};

  &:focus {
    outline: none;
  }
`;
const ErrorMessage = styled_components_1.default.p `
  margin-top: 4px;
  margin-bottom: 0;
  font-weight: normal;
  font-style: italic;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.error.main};
  position: absolute;
  bottom: -16px;
`;
const InputWrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;
  border: ${({ isError, isSuccess, isDisabled, theme }) => {
    const color = isDisabled
        ? theme.neutral.main
        : isError
            ? theme.error.main
            : isSuccess
                ? theme.success.main
                : theme.neutral.main;
    return `1px solid ${color}`;
}};
  background-color: ${({ isDisabled, theme }) => isDisabled ? theme.neutral.lighter : theme.white};
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  ${({ isFocused }) => isFocused &&
    (0, styled_components_1.css) `
      outline: none;
      border-color: ${({ isError, isSuccess, theme }) => {
        if (isError) {
            return theme.error.main;
        }
        else if (isSuccess) {
            return theme.success.main;
        }
        else {
            return theme.primary.main;
        }
    }};
    `};
`;
const RotaTextarea = (0, react_1.forwardRef)((_a, ref) => {
    var { id, label, rows = 4, width, errorMessage, isError = false, isSuccess = false, isDisabled = false, placeholder, onChange, onBlur, value, wrapperStyles } = _a, props = __rest(_a, ["id", "label", "rows", "width", "errorMessage", "isError", "isSuccess", "isDisabled", "placeholder", "onChange", "onBlur", "value", "wrapperStyles"]);
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    return (react_1.default.createElement(Wrapper, { width: width, style: Object.assign({}, wrapperStyles) },
        label && react_1.default.createElement(Label, { htmlFor: id }, label),
        react_1.default.createElement(InputWrapper, { isError: isError, isSuccess: isSuccess, isFocused: isFocused, isDisabled: isDisabled },
            react_1.default.createElement(Textarea, Object.assign({ id: id, ref: ref, placeholder: placeholder, onChange: onChange, onFocus: () => setIsFocused(true), onBlur: e => {
                    onBlur && onBlur(e);
                    setIsFocused(false);
                }, value: value, disabled: isDisabled, rows: rows }, props))),
        isError && errorMessage && react_1.default.createElement(ErrorMessage, null, errorMessage)));
});
exports.default = RotaTextarea;
